// Parses the entry source (social vs website) from the URL and referrer.
const CHANNELS = {
  facebook: "Facebook",
  fb: "Facebook",
  instagram: "Instagram",
  ig: "Instagram",
  tiktok: "TikTok",
  linkedin: "LinkedIn",
  google: "Google",
  website: "our website",
};

const SOCIAL = ["Facebook", "Instagram", "TikTok", "LinkedIn"];

export function parseEntrySource() {
  const p = new URLSearchParams(window.location.search);
  const raw = (p.get("src") || p.get("source") || "").toLowerCase();
  const channel = CHANNELS[raw] || "our website";
  const isSocial = SOCIAL.includes(channel);

  const prefill = {
    first_name: p.get("first_name") || p.get("firstName") || "",
    last_name: p.get("last_name") || p.get("lastName") || "",
    email: p.get("email") || "",
    mobile: p.get("phone") || p.get("mobile") || "",
  };

  const source = {
    channel,
    is_social: isSocial,
    landing_page: p.get("landing") || window.location.pathname,
    landing_url: window.location.href,
    referrer: document.referrer || "",
    utm: {
      source: p.get("utm_source") || "",
      medium: p.get("utm_medium") || "",
      campaign: p.get("utm_campaign") || "",
      term: p.get("utm_term") || "",
      content: p.get("utm_content") || "",
    },
  };

  return { channel, isSocial, prefill, source, platformName: isSocial ? channel : "our website" };
}
